import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { addCommentRequest, fetchAssignableUsers, fetchComments, fetchMe, fetchTimeline } from '../api/endpoints';
import type { Comment, CommentVisibility } from '../types/api';
import { queryKeys } from './queryKeys';

export function useComments(ticketId: string) {
  return useQuery({ queryKey: queryKeys.tickets.comments(ticketId), queryFn: () => fetchComments(ticketId) });
}

export function useAddComment(ticketId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: { body: string; visibility: CommentVisibility; parentId?: string }) => addCommentRequest(ticketId, input),
    onSuccess: (comment) => {
      qc.setQueryData<Comment[]>(queryKeys.tickets.comments(ticketId), (prev) => [...(prev ?? []), comment]);
      void qc.invalidateQueries({ queryKey: queryKeys.tickets.timeline(ticketId) });
      void qc.invalidateQueries({ queryKey: queryKeys.tickets.detail(ticketId), exact: true }); // SLA first response
    },
  });
}

export function useTimeline(ticketId: string, enabled: boolean) {
  return useQuery({ queryKey: queryKeys.tickets.timeline(ticketId), queryFn: () => fetchTimeline(ticketId), enabled });
}

export function useMe(enabled: boolean) {
  return useQuery({ queryKey: queryKeys.me, queryFn: fetchMe, enabled, staleTime: 5 * 60_000 });
}

export function useAssignableUsers(enabled: boolean) {
  return useQuery({ queryKey: queryKeys.assignable, queryFn: fetchAssignableUsers, enabled, staleTime: 5 * 60_000 });
}
